module.exports = __webpack_public_path__ + "img/ifpi-start-hero.c12abcc7.jpg";